import React, { useState } from 'react';
import { BiVideo } from 'react-icons/bi';
import { FaYoutube, FaInstagram } from 'react-icons/fa';
import { useVideos } from '../context/VideosContext';
import InstagramEmbed from '../components/InstagramEmbed';
import './Videos.css';

// Supports youtube.com/watch, youtu.be, and youtube.com/shorts links
const parseYoutubeId = (url) => {
    const match = (url || '').match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|shorts\/|embed\/))([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : url;
};

const Videos = () => {
    const { getInstagramVideos, getYoutubeVideos, loading } = useVideos();
    const [selectedVideo, setSelectedVideo] = useState(null);

    const instagramVideos = getInstagramVideos();
    const youtubeVideos = getYoutubeVideos();

    const handleVideoClick = (video) => {
        setSelectedVideo({ ...video, videoId: parseYoutubeId(video.url) });
    };

    const closeVideoPlayer = () => {
        setSelectedVideo(null);
    };

    let instagramContent = <div className="instagram-grid">
        {instagramVideos.map((video) => (
            <div key={video.id} className="instagram-card">
                <InstagramEmbed url={video.url} />
            </div>
        ))}
    </div>;
    if (loading) instagramContent = <p>Loading videos...</p>;
    else if (instagramVideos.length === 0) instagramContent = <p>No Instagram videos yet.</p>;

    let youtubeContent = <div className="videos-grid">
        {youtubeVideos.map((video) => (
            <div 
                key={video.id} 
                className="video-card"
                onClick={() => handleVideoClick(video)}
            >
                <div className="video-thumbnail">
                    <img
                        src={`https://img.youtube.com/vi/${parseYoutubeId(video.url)}/maxresdefault.jpg`}
                        alt={video.title}
                    />
                    <div className="play-overlay">
                        <BiVideo size={40} />
                    </div>
                    {video.category === 'short' && <span className="shorts-badge">Shorts</span>}
                </div>
                <div className="video-info">
                    <h3>{video.title}</h3>
                    <p className="channel-name">Aditi's Corner</p>
                </div>
            </div>
        ))}
    </div>;
    if (loading) youtubeContent = <p>Loading videos...</p>;
    else if (youtubeVideos.length === 0) youtubeContent = <p>No YouTube videos yet.</p>;

    return (
        <div className="videos-page">
            <div className="page-header">
                <div className="header-content">
                    <h1>Fashion Videos</h1>
                    <p>Watch our latest collections and styling tips</p>
                </div>
            </div>

            {/* Instagram Reels Section */}
            <div className="video-section">
                <div className="section-title-row">
                    <h2 className="section-title">Instagram Reels</h2>
                    <a 
                        href="https://www.instagram.com/aditi_textile/" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="instagram-profile-link"
                    >
                        <FaInstagram size={24} />
                        Visit Profile
                    </a>
                </div>
                {instagramContent}
            </div>

            {/* YouTube Videos Section */}
            <div className="video-section">
                <div className="section-title-row">
                    <h2 className="section-title">YouTube Videos</h2>
                    <a 
                        href="https://www.youtube.com/@AditisCorner-z6h" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="youtube-channel-link"
                    >
                        <FaYoutube size={24} />
                        Visit Channel
                    </a>
                </div>
                {youtubeContent}
            </div>

            {/* Video Player Modal */}
            {selectedVideo && (
                <div className="video-modal" onClick={closeVideoPlayer}>
                    <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="close-modal" onClick={closeVideoPlayer} aria-label="Close video player">×</button>
                        <iframe
                            width="100%"
                            height="100%"
                            src={`https://www.youtube.com/embed/${selectedVideo.videoId}`}
                            title={selectedVideo.title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Videos;
